export default "__VITE_ASSET__NJ17WJIf__"